"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  width: 960,
  height: 500,
  margins: { top: 80, right: 100, bottom: 80, left: 100 }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-d3-core/lib/commonProps.js
// module id = 56
// module chunks = 0